var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.hasError === true)?_c('div',[_c('v-icon',{attrs:{"size":_vm.iconSize,"color":'red'}},[_vm._v("mdi-close")])],1):_c('div',[_c('v-icon',{attrs:{"size":_vm.iconSize,"color":'green'}},[_vm._v("fa-check")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }